<template>
  <div class="userMenu">
    <div class="userMenu1">
      <el-image
        class="userMenu1img"
        shape="circle"
        :size="130"
        :src="avatar"
        fit="scale-down"
      ></el-image>
      <p class="user-name">{{ $store.getters.name }}</p>
      <div class="userMenu1ul">
        <li>
          <p>{{ countIntegral || "0" }}</p>
          <span>积分数量</span>
        </li>
        <li>
          <p>{{ orderCount }}</p>
          <span>订单数量</span>
        </li>
        <li>
          <p>{{ resourceCount }}</p>
          <span>商品数量</span>
        </li>
      </div>
      <div class="userMenu2">
        <ul>
          <li
            v-for="(item, index) in menulist"
            :key="index"
            @click="change(item)"
            :class="$route.meta.title === item.name ? 'active' : ''"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { IntegralCount } from "@/api/user/order";
import {
  selectMyResourceListGoods,
  selectMyResourceListSubject,
  selectMyResourceListBundle,
} from "@/api/user/myResources.js";
import { apiGetUserOrderList } from "@/api/user/order";
export default {
  name: "userMenu",
  data() {
    return {
      menulist: [
        {
          name: "我的书架",
          path: "/user/myResources",
        },
        {
          name: "我的课程",
          path: "/user/myCourse",
        },
        {
          name: "错题本",
          path: "/user/errorBook",
          path: "/user/errorBookV2",
        },
        {
          name: "我的订单",
          path: "/user/myOrder",
        },
        {
          name: "我的评价",
          path: "/user/myEvaluate",
        },
        // {
        //   name: "我的笔记",
        //   path: "/user/mynote",
        // },
        {
          name: "账户管理",
          path: "/user/accountManage",
        },
        {
          name: "消息通知",
          path: "/user/notification",
        },
        {
          name: "积分明细",
          path: "/user/integrate",
        },
        {
          name: "学习记录",
          path: "/user/learningRecord",
        },

      ],
      orderCount: " - ",
      countIntegral: 0,
    };
  },
  created() {
    if (this.userId) {
      apiGetUserOrderList({
        pageNum: 1,
        pageSize: 1,
        userId: this.userId,
      }).then((res) => {
        let { total } = res;
        this.orderCount = total === 0 ? total : total || " - ";
      });
      this.IntegralCount();
      selectMyResourceListGoods({ pageNum: 1, pageSize: 1 }).then((res) => {
        this.$store.commit("SET_MYGOODSNUM", res.total);
      });
      selectMyResourceListSubject({ pageNum: 1, pageSize: 1 }).then((res) => {
        this.$store.commit("SET_MYSUBJECTNUM", res.total);
      });
      selectMyResourceListBundle({ pageNum: 1, pageSize: 1 }).then((res) => {
        this.$store.commit("SET_MYBUNDLENUM", res.total);
      });
    }
  },
  methods: {
    change(item) {
      this.$router.push({ path: item.path });
    },
    IntegralCount() {
      IntegralCount().then((res) => {
        if (res.code == 200) {
          this.countIntegral = res.data;
        }
      });
    },
  },
  computed: {
    ...mapGetters(["avatar", "userId"]),
    resourceCount() {
      let value = this.$store.getters.myResourceNum;
      return value === 0 ? value : value || " - ";
    },
  },
};
</script>

<style scoped>
.userMenu {
  width: 304px;
  min-height: 300px;
  background: #fffefd;
  float: left;
  margin-right: 16px;
  height: fit-content;
}
.userMenu1 {
  width: 100%;
  float: left;
}
.userMenu1img {
  width: 130px;
  height: 130px;
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 50%;
}
.userMenu1 > p {
  display: table;
  margin: 0 auto;
  font-size: 16px;
  margin-bottom: 25px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.userMenu1ul {
  width: 100%;
  display: flex;
}
.userMenu1ul li {
  flex: 1;
  list-style: none;
  border-right: 1px solid #f2f2f2;
}
.userMenu1ul li:last-child {
  border: 0;
}
.userMenu1ul li p {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  margin-bottom: 5px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #2e9adb;
  line-height: 21px;
}
.userMenu1ul li span {
  width: 100%;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 21px;
}
.userMenu2 {
  width: 100%;
  float: left;
  padding: 14px 14px 6px;
  box-sizing: border-box;
}
.userMenu2 ul {
  border-top: 1px solid #f2f2f2;
}
.userMenu2 li {
  list-style: none;
  width: 100%;
  height: 46px;
  line-height: 46px;
  border-bottom: 1px solid #f2f2f2;
  font-size: 14px;
  position: relative;
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 400;
  padding-left: 17px;
  box-sizing: border-box;
  color: #333333;
}
.userMenu2 li.active:before {
  content: "";
  width: 4px;
  height: 22px;
  background: #2e9adb;
  display: block;
  position: absolute;
  top: 11px;
  left: 6px;
}
.userMenu2 li.active {
  color: #2e9adb;
}
.userMenu2 li:hover:before {
  content: "";
  width: 4px;
  height: 22px;
  background: #2e9adb;
  display: block;
  position: absolute;
  top: 11px;
  left: 6px;
}
.userMenu2 li:hover {
  color: #2e9adb;
}
.userMenu2 li:last-child {
  border-bottom: none;
}
.user-name {
  display: block;
  padding: 0 14px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /*行数*/
  -webkit-box-orient: vertical;
}
</style>
